import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.post(HTTP.SERVICE_FIELDS_LIST),
    addServicefield: payload => axios.post(HTTP.SERVICE_FIELD, payload),
    updateServicefield: payload => axios.put(HTTP.SERVICE_FIELD, payload),
    deleteServicefield: payload => axios.delete(HTTP.SERVICE_FIELD, { params: { id: payload } })
}
